import { render, staticRenderFns } from "./LoginSignupTabs.vue?vue&type=template&id=787bc502&scoped=true"
import script from "./LoginSignupTabs.vue?vue&type=script&lang=js"
export * from "./LoginSignupTabs.vue?vue&type=script&lang=js"
import style0 from "./LoginSignupTabs.vue?vue&type=style&index=0&id=787bc502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787bc502",
  null
  
)

export default component.exports